import { Coins } from 'lucide-react';
import type { GenerationMode, ModelConfig } from '../../services/api';

interface ImageCreditsPreviewProps {
  model?: ModelConfig;
  mode: GenerationMode;
  quality: string;
  count: number;
  userCredits?: number;
}

export function ImageCreditsPreview({
  model,
  mode,
  quality,
  count,
  userCredits,
}: ImageCreditsPreviewProps) {
  if (!model) {
    return (
      <div className="flex items-center gap-2 rounded-xl border border-light-border bg-white px-3 py-2.5 text-light-text">
        <Coins className="h-4 w-4" />
        <span className="text-sm text-light-muted">选择参数后预估积分</span>
      </div>
    );
  }

  const qualityCredits = model.credits[quality as keyof ModelConfig['credits']] ?? model.credits.low ?? 1;
  const modeCredits = model.modeCredits?.[mode] ?? 0;
  const creditsPerImage = qualityCredits + modeCredits;
  const totalCredits = creditsPerImage * Math.max(1, count);
  const insufficient = userCredits != null && userCredits < totalCredits;

  return (
    <div
      className={`flex items-center gap-2 rounded-xl border px-3 py-2.5 ${
        insufficient
          ? 'border-rose-200 bg-rose-50 text-rose-700'
          : 'border-light-border bg-white text-light-text'
      }`}
    >
      <Coins className="h-4 w-4" />
      <span className="text-sm">
        本次将扣除
        <span className={`mx-1 font-semibold ${insufficient ? 'text-rose-700' : 'text-accent-blue'}`}>
          {totalCredits}
        </span>
        积分
        {count > 1 && (
          <span className="ml-1 text-xs text-light-muted">
            ({count} × {creditsPerImage})
          </span>
        )}
        {insufficient && <span className="ml-2 text-xs text-rose-600">积分不足</span>}
      </span>
    </div>
  );
}
